// The pricing-card lines for one plan, built from the plan features edited in
// Admin → Pricing (docs/services.md §7). Identical file in frontend-landing and
// frontend-app (a test fails if they differ): the marketing cards and the
// dashboard's billing cards must list the same things.
//
// `catalogue`  GET /billing/plans `features`: [{ key, kind, nameAr, nameEn,
//              unitAr, unitEn, showOnPricing, sortOrder }]
// `values`     that plan's `features`: [{ key, enabled, limit }], limit null =
//              unlimited
// `labels`     { unlimited } in the page language
//
// Listed: features shown on pricing AND included in the plan, in catalogue
// order. A switch is its name; a limit is "name: 50 unit" or
// "name: Unlimited". Returns null when the server sent no catalogue (an older
// billing image) so the caller keeps its own fallback text.
export function planFeatureLines(catalogue, values, lang, labels) {
  if (!Array.isArray(catalogue) || catalogue.length === 0) return null;
  const byKey = new Map((values ?? []).map((v) => [v.key, v]));
  const ar = lang === 'ar';
  return [...catalogue]
    .filter((f) => f.showOnPricing && byKey.get(f.key)?.enabled)
    .sort((a, b) => (a.sortOrder ?? 0) - (b.sortOrder ?? 0))
    .map((f) => {
      const name = (ar ? f.nameAr : f.nameEn) || f.nameEn || f.nameAr || f.key;
      if (f.kind !== 'limit') return name;
      const limit = byKey.get(f.key).limit;
      if (limit === null || limit === undefined) return `${name}: ${labels.unlimited}`;
      const unit = ar ? f.unitAr : f.unitEn;
      return `${name}: ${Number(limit).toLocaleString('en-US')}${unit ? ` ${unit}` : ''}`;
    });
}
